(function initLoginOtpAnalytics() {
  if (window.JPLoginOtpAnalytics) return;

  const START_KEY = 'jp_login_start_at';
  const COMPLETE_KEY = 'jp_login_complete_sent';
  const REDIRECT_KEY = 'jp_login_redirect_sent';
  const STEP_KEY = 'jp_login_last_step';
  const ABANDON_KEY = 'jp_login_abandoned_sent';
  const SUPPRESS_KEY = 'jp_login_abandon_suppress';
  const RETURN_URL_KEY = 'otp_post_login_checkout_redirect';
  const MAX_LOGIN_SECONDS = 30 * 60;
  const state = {
    resendCount: 0,
    customerStatus: 'enabled'
  };

  const normalizeChannel = (value) => (
    String(value || '').trim().toLowerCase() === 'sms' ? 'sms' : 'email'
  );

  const normalizeLastLoginMethod = (value) => String(value || '').trim().toLowerCase();

  const normalizePhoneVerified = (value) => {
    if (value === true) return true;
    if (value === false) return false;
    if (value == null) return null;
    const normalized = String(value).trim().toLowerCase();
    if (normalized === 'true') return true;
    if (normalized === 'false') return false;
    return null;
  };

  const resolveMethod = (data, requestChannel) => {
    const lastLogin = normalizeLastLoginMethod(data && data.lastLogin);
    if (lastLogin === 'password') return 'password';
    if (lastLogin === 'passcode_sms') return 'otp_sms';
    if (lastLogin === 'passcode_email') return 'otp_email';
    return normalizeChannel((data && data.channel) || requestChannel) === 'sms' ? 'otp_sms' : 'otp_email';
  };

  const resolveChannelMethod = (channel) => (
    normalizeChannel(channel) === 'sms' ? 'otp_sms' : 'otp_email'
  );

  const resolveCustomerStatus = (data) => {
    const raw = data && (data.customerState != null ? data.customerState : data.customerStatus);
    const normalized = String(raw || '').trim().toLowerCase();
    if (normalized === 'disabled' || normalized === 'invited') return 'disabled';
    if (normalized === 'enabled' || normalized === 'active') return 'enabled';
    return normalized === 'false' ? 'disabled' : 'enabled';
  };

  const resolveSendErrorReason = (data, apiStatus) => {
    const fromApi = String((data && (data.errorReason || data.error || data.message)) || '').trim();
    const statusReason = String(apiStatus || '').trim();
    return (fromApi || statusReason || 'request_failed').toLowerCase().replace(/\s+/g, '_') || 'request_failed';
  };

  const resolveVerifyFailureReason = (apiStatus, data) => {
    const fromApi = String((data && (data.failureReason || data.errorReason || data.error)) || '').trim().toLowerCase();
    if (fromApi === 'expired' || fromApi === 'otp_expired') return 'expired';
    if (fromApi === 'wrong code' || fromApi === 'wrong_code' || fromApi === 'invalid' || fromApi === 'otp_invalid') {
      return 'wrong_code';
    }
    if (apiStatus === 'OTP_EXPIRED' || apiStatus === 'OTP_LOCKED') return 'expired';
    if (apiStatus === 'OTP_INVALID_OR_EXPIRED' || apiStatus === 'OTP_INVALID' || apiStatus === 'INVALID_OTP') {
      return 'wrong_code';
    }
    return fromApi.replace(/\s+/g, '_') || 'wrong_code';
  };

  const push = (name, props) => {
    window.dataLayer = window.dataLayer || [];
    const payload = { event: name };
    if (!props) {
      window.dataLayer.push(payload);
      return;
    }
    for (const key in props) {
      if (!Object.prototype.hasOwnProperty.call(props, key)) continue;
      if (props[key] == null || props[key] === '') continue;
      payload[key] = props[key];
    }
    window.dataLayer.push(payload);
  };

  const shouldLoginStart = (opts, requestType) => {
    if (!opts || opts.isResend) return false;
    if (opts.channel) return false;
    if (opts.selectionFallbackTried || opts.phoneNotVerifiedFallbackTried) return false;
    return String(requestType || '').toUpperCase() !== 'OTP';
  };

  const normalizeStep = (value) => {
    const step = String(value || '').trim().toLowerCase();
    if (step === 'verify' || step === 'otp' || step === 'otp_verify') return 'otp_verify';
    if (step === 'password') return 'password';
    if (step === 'request' || step === 'email') return 'email';
    return '';
  };

  const setStep = (value) => {
    const step = normalizeStep(value);
    if (!step) return;
    try {
      const previous = normalizeStep(sessionStorage.getItem(STEP_KEY));
      sessionStorage.setItem(STEP_KEY, step);
      sessionStorage.removeItem(SUPPRESS_KEY);
      if (previous !== step) sessionStorage.removeItem(ABANDON_KEY);
      if (sessionStorage.getItem(START_KEY)) return;
      sessionStorage.setItem(START_KEY, String(Date.now()));
      sessionStorage.removeItem(COMPLETE_KEY);
      sessionStorage.removeItem(REDIRECT_KEY);
      sessionStorage.removeItem(ABANDON_KEY);
    } catch (e) {}
  };

  const inferStepFromDom = () => {
    const verify = document.getElementById('login-otp-step-verify');
    if (verify && !verify.classList.contains('hidden')) return 'otp_verify';
    const password = document.getElementById('customer-login-password-shell');
    if (password && !password.classList.contains('hidden')) return 'password';
    const request = document.getElementById('login-otp-step-request');
    if (request && !request.classList.contains('hidden')) return 'email';
    return '';
  };

  const resolveLastStep = () => {
    let stored = '';
    try {
      stored = normalizeStep(sessionStorage.getItem(STEP_KEY));
    } catch (e) {}
    return stored || inferStepFromDom() || 'email';
  };

  const isLoginPage = () => String(window.location.pathname || '').indexOf('/account/login') !== -1;

  const linkUrl = (el) => {
    const href = el && el.getAttribute ? el.getAttribute('href') : '';
    if (!href || href === '#') return null;
    if (href.charAt(0) === '#') return null;
    try {
      return new URL(href, window.location.href);
    } catch (e) {
      return null;
    }
  };

  const navigatesToNewDocument = (el) => {
    const url = linkUrl(el);
    if (!url) return false;
    if (url.origin !== window.location.origin) return true;
    return url.pathname !== window.location.pathname || url.search !== window.location.search;
  };

  const destinationIsLogin = (el) => {
    const url = linkUrl(el);
    if (!url) return false;
    return url.pathname.indexOf('/account/login') !== -1;
  };

  const abandonPendingLogin = (opts) => {
    const fromClick = !!(opts && opts.fromClick);
    try {
      if (!fromClick && sessionStorage.getItem(SUPPRESS_KEY) === '1') {
        sessionStorage.removeItem(SUPPRESS_KEY);
        return;
      }
      if (sessionStorage.getItem(COMPLETE_KEY) === '1') return;
      if (sessionStorage.getItem(ABANDON_KEY) === '1') return;
      if (localStorage.getItem('user_login_attempt') === 'true') return;
      if (!sessionStorage.getItem(START_KEY)) return;
      if (!isLoginPage()) return;
      sessionStorage.setItem(ABANDON_KEY, '1');
      const lastStep = resolveLastStep();
      sessionStorage.removeItem(STEP_KEY);
      clearLoginStartTime();
      push('login_abandoned', {
        last_step: lastStep
      });
    } catch (e) {}
  };

  const suppressAbandonForLoginStay = () => {
    try {
      sessionStorage.setItem(SUPPRESS_KEY, '1');
    } catch (e) {}
  };

  const bindLoginAbandonClicks = () => {
    if (document.__jpLoginAbandonBound) return;
    document.__jpLoginAbandonBound = true;
    document.addEventListener('click', (event) => {
      if (!isLoginPage()) return;
      if (event.defaultPrevented) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      const el = event.target && event.target.closest ? event.target.closest('a[href]') : null;
      if (!el) return;
      if (el.target === '_blank') return;
      if (!navigatesToNewDocument(el)) return;
      if (destinationIsLogin(el)) {
        suppressAbandonForLoginStay();
        return;
      }
      abandonPendingLogin({ fromClick: true });
    });
  };

  const bindLoginNavigationSuppress = () => {
    const navigation = window.navigation;
    if (!navigation || !navigation.addEventListener || navigation.__jpLoginAbandonBound) return;
    navigation.__jpLoginAbandonBound = true;
    navigation.addEventListener('navigate', (event) => {
      if (!isLoginPage()) return;
      const destination = event.destination;
      if (!destination || destination.sameDocument) return;
      let url = null;
      try {
        url = new URL(destination.url);
      } catch (e) {
        return;
      }
      const staysOnLogin = url.origin === window.location.origin
        && url.pathname.indexOf('/account/login') !== -1;
      if (!staysOnLogin && event.navigationType !== 'reload') return;
      suppressAbandonForLoginStay();
    });
  };

  const markLoginStartTime = () => {
    try {
      sessionStorage.setItem(START_KEY, String(Date.now()));
      sessionStorage.removeItem(COMPLETE_KEY);
      sessionStorage.removeItem(REDIRECT_KEY);
      sessionStorage.removeItem(ABANDON_KEY);
      sessionStorage.setItem(STEP_KEY, 'email');
    } catch (e) {}
  };

  const toAbsoluteUrl = (value) => {
    const raw = String(value || '').trim();
    if (!raw) return '';
    try {
      return new URL(raw, window.location.origin).href;
    } catch (e) {
      return raw;
    }
  };

  const resolveReturnUrl = (fallback) => {
    const fromFallback = toAbsoluteUrl(fallback);
    if (fromFallback) return fromFallback;
    try {
      const fromSession = toAbsoluteUrl(sessionStorage.getItem(RETURN_URL_KEY));
      if (fromSession) return fromSession;
    } catch (e) {}
    try {
      const fromLocal = toAbsoluteUrl(localStorage.getItem(RETURN_URL_KEY));
      if (fromLocal) return fromLocal;
    } catch (e2) {}
    try {
      const params = new URLSearchParams(window.location.search);
      const fromParam = toAbsoluteUrl(
        params.get('checkout_url') || params.get('return_url') || params.get('return_to')
      );
      if (fromParam) return fromParam;
    } catch (e3) {}
    try {
      if (localStorage.getItem('redirect_checkout') === 'true') {
        return toAbsoluteUrl('/checkout');
      }
    } catch (e4) {}
    return '';
  };

  const hasReturnUrl = (fallback) => !!resolveReturnUrl(fallback);

  const redirect = (returnUrl) => {
    const url = resolveReturnUrl(returnUrl);
    if (!url) return;
    try {
      if (sessionStorage.getItem(REDIRECT_KEY) === '1') return;
      sessionStorage.setItem(REDIRECT_KEY, '1');
    } catch (e) {}
    push('login_redirect', {
      url
    });
  };

  const loginStart = (data, requestChannel) => {
    const payload = data || {};
    const phoneVerified = normalizePhoneVerified(payload.phoneVerified);
    state.customerStatus = resolveCustomerStatus(payload);
    markLoginStartTime();
    push('login_start', {
      method: resolveMethod(payload, requestChannel),
      status: state.customerStatus,
      phone_verified: phoneVerified === true ? 'true' : 'false'
    });
  };

  const clearLoginStartTime = () => {
    try {
      sessionStorage.removeItem(START_KEY);
    } catch (e) {}
  };

  const complete = () => {
    let startAt = 0;
    try {
      if (sessionStorage.getItem(COMPLETE_KEY) === '1') return;
      startAt = Number(sessionStorage.getItem(START_KEY) || 0);
      if (!startAt) return;
      const seconds = Math.max(0, Math.round((Date.now() - startAt) / 1000));
      sessionStorage.removeItem(START_KEY);
      if (seconds > MAX_LOGIN_SECONDS) return;
      sessionStorage.setItem(COMPLETE_KEY, '1');
      sessionStorage.removeItem(STEP_KEY);
      sessionStorage.removeItem(ABANDON_KEY);
      push('login_complete', {
        time_to_login_sec: seconds
      });
      redirect();
    } catch (e) {}
  };

  const bindLoginComplete = () => {
    window.dataLayer = window.dataLayer || [];
    const inspect = (item) => {
      if (!item || typeof item !== 'object') return;
      if (String(item.event || '').trim() !== 'login') return;
      if (Number(item.results) !== 1) return;
      complete();
    };
    for (const item of window.dataLayer) inspect(item);
    if (window.dataLayer.__jpLoginCompleteBound) return;
    window.dataLayer.__jpLoginCompleteBound = true;
    const originalPush = window.dataLayer.push;
    window.dataLayer.push = function () {
      const result = originalPush.apply(window.dataLayer, arguments);
      for (let i = 0; i < arguments.length; i += 1) inspect(arguments[i]);
      return result;
    };
  };

  const loginChange = (method, data) => {
    if (data) state.customerStatus = resolveCustomerStatus(data);
    const normalizedMethod = String(method || '').trim().toLowerCase();
    const nextMethod = normalizedMethod === 'otp_sms' || normalizedMethod === 'sms'
      ? 'otp_sms'
      : normalizedMethod === 'password'
        ? 'password'
        : 'otp_email';
    push('login_change', {
      method: nextMethod,
      status: state.customerStatus
    });
  };

  const sendFailed = (data, apiStatus, requestChannel) => {
    push('otp_send_failed', {
      method: resolveChannelMethod((data && data.channel) || requestChannel),
      error_reason: resolveSendErrorReason(data, apiStatus)
    });
  };

  const verifySuccess = (channel) => {
    push('otp_verify_success', {
      method: resolveChannelMethod(channel)
    });
  };

  const verifyFailed = (apiStatus, data, channel) => {
    push('otp_verify_failed', {
      method: resolveChannelMethod((data && data.channel) || channel),
      failure_reason: resolveVerifyFailureReason(apiStatus, data)
    });
  };

  const resent = (channel) => {
    state.resendCount += 1;
    push('otp_resent', {
      method: resolveChannelMethod(channel),
      resend_count: state.resendCount
    });
  };

  window.JPLoginOtpAnalytics = {
    shouldLoginStart,
    loginStart,
    loginChange,
    sendFailed,
    verifySuccess,
    verifyFailed,
    resent,
    complete,
    hasReturnUrl,
    redirect,
    setStep
  };

  bindLoginComplete();
  bindLoginAbandonClicks();
  bindLoginNavigationSuppress();
  window.addEventListener('pagehide', () => abandonPendingLogin());
  window.addEventListener('pageshow', () => {
    if (!isLoginPage()) return;
    const step = inferStepFromDom();
    if (!step) return;
    setStep(step);
  });
})();
